//date library date-fns uses special date format pattern symbols, below is the docs
//https://date-fns.org/v2.29.3/docs/format
export const DATE_TIME_FORMAT = "dd MMM yyyy hh:mm a";
export const DATE_TIME_LONG_FORMAT = "dd MMMM yyyy hh:mm a";
export const DATE_TIME_SHORT_FORMAT = "dd/MM/yyyy hh:mm a";
export const DATE_FORMAT = "dd MMM yyyy";
export const DATE_LONG_FORMAT = "dd MMMM yyyy";
export const DATE_PICKER_FORMAT = "yyyy-MM-dd";
export const TIME_FORMAT = "hh:mm a";
export const DATE_DAY_FORMAT = "ccc dd/MM/yyyy";
